import { render, staticRenderFns } from "./SeparatingComponentsOfAMixtureSIM.vue?vue&type=template&id=0f78c216&"
import script from "./SeparatingComponentsOfAMixtureSIM.vue?vue&type=script&lang=ts&"
export * from "./SeparatingComponentsOfAMixtureSIM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports